import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var DownloadIcon = function DownloadIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "DownloadIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M8 1c.504 0 .913.409.913.913v5.912l2.5-2.5a.913.913 0 1 1 1.29 1.292L9.22 10.1l-.016.016a5 5 0 0 1-.28.265c-.108.091-.267.21-.485.28a1.42 1.42 0 0 1-.878 0 1.4 1.4 0 0 1-.485-.28 5 5 0 0 1-.28-.265L6.78 10.1 3.297 6.617a.913.913 0 1 1 1.292-1.292l2.499 2.5V1.913C7.087 1.409 7.496 1 8 1M1 14.087c0-.504.409-.913.913-.913h12.174a.913.913 0 0 1 0 1.826H1.913A.913.913 0 0 1 1 14.087",
      clipRule: "evenodd"
    })
  }));
};

export { DownloadIcon };
